import Index from './index.vue'
import Login from './components/Login.vue'
import Logout from './components/Logout.vue'

export default [
  {
    path: '/login',
    name: 'login',
    component: Index,
    title: 'Login',
    children: [
      {
        path: '/',
        name: 'authentication-login',
        component: Login,
        props: true,
      },
    ],
  },
  {
    path: '/logout',
    component: Logout,
  },
]
